/**
 * @module websocket.event.handlers.baggages.baggage-added
 */
import { store } from '../../../../state/store'
import { setBaggageListUpdated } from '../../../../state/websocket.slice'

export default function handleBaggageAdded(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleBaggageAdded', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setBaggageListUpdated(data))
  }
} 